import React, { useContext, useState } from "react";
import {
  AppBar as MuiAppBar,
  Toolbar,
  Button,
  Box,
  Stack,
  Typography,
  GTIWebButton,
  Apartment, Link
} from "@gti-controls-v2/web-core";
import {
  AccountCircle,
  ArrowDropUp,
  ArrowDropDown,
} from "@gti-controls-v2/web-core"; //iconos
import Popover from "./popover";
import PopoverUsuario from "./popover-usuario";
import consumosStyles from "../../common/styles/Consumos";
import LogoRevolution from "../../assets/Logo-Revolution-White.svg"
import MediaQuery from "react-responsive";
import { useMediaQueryCustom } from "../../hooks/useMediaQueryCustom/useMediaQueryCustom";
import customTheme from "../../theme";
import { AuthContext } from "../../providers/auth";
import useTranslation from "../../hooks/useTranslation";

export const AppBar = (props) => {

  const { user } = useContext( AuthContext );
  const { isMobile480, isTablet768, isTablet1024 } = useMediaQueryCustom();
  const { t } = useTranslation();
  const styles = consumosStyles;
  const [anchorEl, setAnchorEl] = useState(null);
  const [activePopover, setActivePopover] = useState(null);


  const handlePopoverClick = (event, name) => {
    setAnchorEl(event.currentTarget);
    setActivePopover(name);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setActivePopover(null);
  };


  return (
    <MuiAppBar sx={styles.appBar} position="fixed">
      <Toolbar
        style={{
          height: isMobile480 ? customTheme.spacing(5) : isTablet768 ? customTheme.spacing(6) : isTablet1024 ? customTheme.spacing(6) : customTheme.spacing(8),
          minHeight: isMobile480 ? customTheme.spacing(5) : isTablet768 ? customTheme.spacing(6) : isTablet1024 ? customTheme.spacing(6) : customTheme.spacing(8)
        }}
      >
        <Link
          to={"#"}
          style={{ textDecoration: "none" }}
        >
          <Box>
            <img src={LogoRevolution} width={isMobile480 ? "100px" : isTablet768 ? "125px" : "150px"} alt="" style={{verticalAlign:"middle"}} />
          </Box>
        </Link>


        <Box sx={styles.spacer} />

        <Box sx={styles.logout}>
          <Stack direction="row" spacing={2} alignItems="center">
            <Link
              color="inherit"
              component="button"
              variant="body2"
              fontSize={isMobile480 ? "12px" : isTablet768 ? "14px" : isTablet1024 ? "14px" : "20px"}
              onClick={() => {
                props.setCajaOpen(true);
              }}
            >
              {props.cajaNombre? props.cajaNombre : t("sistema.consumos.titulos.caja")}
            </Link>

            <MediaQuery minWidth={768}>
              <GTIWebButton
                tooltipText={t("sistema.titulos.empresa")}
                onlyIcon={true}
                icon={<Apartment />}
              />

              <Typography style={{ marginLeft: "0" }}
                fontSize={isMobile480 ? "12px" : isTablet768 ? "14px" : isTablet1024 ? "14px" : "20px"}>
                { user?.clienteNombre}
              </Typography>
            </MediaQuery>
          </Stack>
        </Box>
        <Box sx={styles.logout}>
          <Button
            id={"Button_AppBar_Usuario"}
            disableElevation
            variant="text"
            aria-haspopup="true"
            disableRipple
            startIcon={<AccountCircle />}
            endIcon={
              activePopover === "user" ? <ArrowDropUp /> : <ArrowDropDown />
            }
            onClick={(e) => {
              handlePopoverClick(e, "user");
            }}
          >
            <MediaQuery minWidth={768}>
              <Typography style={{ marginLeft: "0" }}
                fontSize={isMobile480 ? "12px" : isTablet768 ? "14px" : isTablet1024 ? "14px" : "20px"}>
                { user?.usuarioNombre}
              </Typography>
            </MediaQuery>
          </Button>
          <Popover
            id="user"
            open={activePopover === "user"}
            anchorEl={anchorEl}
            onClose={handleClose}
          >
            <PopoverUsuario />
          </Popover>
        </Box>
      </Toolbar>
    </MuiAppBar>
  );
};

export default AppBar;
